import { get } from '@navent-jobs/config'
import { EstadisticasAviso } from '../../../store/aviso/estadisticas/types'
import { Estadisticas, PeriodosEstadisticas } from '../../../store/estadisticas/types'

const LOCAL_STORAGE_STATISTICS_PERIOD_KEY = 'estadisticas-generales-period'

class EstadisticasService {
  public getEstadisticas = async (): Promise<Estadisticas> => {
    return get(`api-company/empresas/dashboard/estadisticas`)
  }

  public getEstadisticasConsumo = async (fechaDesde: string, fechaHasta: string) =>
    get(`/api-company/empresas/estadisticas/consumo?fechaDesde=${fechaDesde}&fechaHasta=${fechaHasta}`)

  public getStoredStatisticsPeriod(): PeriodosEstadisticas | null {
    const localStorageValue = localStorage.getItem(LOCAL_STORAGE_STATISTICS_PERIOD_KEY)
    return localStorageValue ? PeriodosEstadisticas[localStorageValue] : null
  }

  public storeStatisticsPeriod(value: PeriodosEstadisticas) {
    localStorage.setItem(LOCAL_STORAGE_STATISTICS_PERIOD_KEY, value.toString())
  }

  public descargarTablaConsumoVistas = async (filename: string, fechaDesde: string, fechaHasta: string) =>
    get(
      `/api-company/empresas/estadisticas/consumo/vistas/descargar?filename=${filename}&fechaDesde=${fechaDesde}&fechaHasta=${fechaHasta}`,
      {
        responseType: 'blob',
      }
    )

  public getEstadisticasAviso = async (idAviso: number): Promise<EstadisticasAviso> =>
    get(`/api-company/empresas/estadisticas/aviso/${idAviso}`)
}

const estadisticasService = new EstadisticasService()
export default estadisticasService
